export type FeatureFlag =
  | FeatureFlagTask
  | FeatureFlagABTest
  | FeatureFlagPartner
  | FeatureFlagCabinRental;

export enum FeatureFlagTask {
  SSX_102_CHECK_PRICE_CAR = "SSX-102",
  SSX_527_AKA_CONSENT = "SSX-527-aka-consent",
  SSX_15_eiendomsverdi = "SSX-15-eiendomsverdi",
  SSX_815_SUMMER_DISCOUNT = "ssx-815-summer-discount",
  SSX_821_AKA_HEALTH_ALREADY_HAS_PRODUCT = "ssx-821-akaHealth-already-has-product-alert",
  SSX_827_IS_EXPECTING_CHILDREN = "SSX-827-is-expecting-children",
  SSX_754_AKA_ADVICE = "SSX-754-aka-advice",
  SSX_754_AKA_ADVICE_ADD_CO_INSURED = "SSX-754-aka-advice-add-co-insured",
  SSX_871_OFFER_CHILD_ADVICE = "SSX-871-offer-child-advice",
  SSX_881_ALREADY_INSURED = "SSX-881-already-insured",
  SSX_1335_ADVICE_PRICE_STEP_CHILD_ADVICE = "ssx-1335-advice-price-step-child-advice",
  OFFER_ACCEPT_DOCUMENT_DOWNLOAD = "ssx-advisor-offer-accept",
  SSX_988_CUSTOMER_ADDRESS = "SSX-988-customer-address",
  SSX_1556_GEODATA_PM = "SSX-1556-geodata-pm",
  SSX_1881_CONTACT_ME = "SSX-1881-contact-me",
  SSX_1955_NEW_FLOW_FIND_CAR = "SSX-1955-new-flow-find-car",
  SSX_1356_ADVICE_REFACTOR = "SSX-1356-advice-refactor",
  SSX_1816_ADDITIONALBUILDING_FROM_EIENDOMSVERDI = "SSX-1816-additional-buildings-from-eiendomsverdi",
  SSX_2245_SOP_CALCULATOR = "SSX-2245-sop-calculator",
  SSX_2464_ENABLE_NEWCHILD_HALF_G = "SSX-2464-enable-newchild-half-g",
  SSX_2400_AKA_PRICE_ALERT = "SSX-2400-aka-price-alert",
  SSX_2325_CHILD_HEALTH = "SSX-2325-child-health-product",
  SSX_2457_ASTUDENT_NEW_TERMS_2025 = "SSX-2457-new-year",
}

export enum FeatureFlagABTest {
  PRODUCT_LINKS_DEFAULT_EXPANDED = "ssx-product-links-default-expanded",
  SSX_1646_ALTERNATIVE_CHILD_LOGIN = "ssx-1646-alternative-login",
  SSX_1950_LOGIN_ONLY_BANKID = "ssx-1950-login-only-bankId",
  SSX_2858_UPSELL = "SSX-2858-upsell",
}

export enum FeatureFlagPartner {
  EDIT_PRODUCT_PARTNER_AKA = "EditProduct-Partner-AKA",
  EDIT_PRODUCT_PARTNER_COOP = "EditProduct-Partner-COOP",
  EDIT_PRODUCT_PARTNER_DANSKE_BANK = "EditProduct-Partner-DANSKEBANK",
  EDIT_PRODUCT_PARTNER_HUSEIERNE = "EditProduct-Partner-HUSEIERNE",
}

export enum FeatureFlagCabinRental {
  ENABLE_CABIN_RENTAL = "ssx-enable-cabin-rental",
}
